import { useIsMobile } from "@/app/redux/features/device/selectors";
import React from "react";

const Big7DrawsEntryPoint = () => {
  const isMobile = useIsMobile();
  const handleClick = () => {
    location.href = "/daily-draws";
  };

  return (
    <img
      onClick={handleClick}
      src={
        isMobile
          ? "/assets/images/big-7-draws/mobile_halloween_menu_entry2.png"
          : "/assets/images/big-7-draws/desktop_halloween_menu_entry2.png"
      }
      // src={isMobile ? "/assets/images/mobile_big7_menu_entry.png" : "/assets/images/desktop_big7_menu_entry.png"}
      alt="Halloween Mega Draws"
      // alt="Summer Daily Draws"
      className="w-full h-auto rounded-lg cursor-pointer object-cover"
    />
  );
};

export default Big7DrawsEntryPoint;
